import { render, staticRenderFns } from "./SharedLeads.vue?vue&type=template&id=c60da5e8"
import script from "../js/sharedLeadsScript.js?vue&type=script&lang=js&external"
export * from "../js/sharedLeadsScript.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports